/**
 * @generated SignedSource<<592510d2faa6218d980782a7cecd5b13>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user">;
  readonly " $fragmentType": "PdpSharedDescriptionAdditionalOptionsContent_user";
};
export type PdpSharedDescriptionAdditionalOptionsContent_user$key = {
  readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptionsContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "862745f2a8b59e551ecc6367246d0c64";

export default node;
